import React, {Component} from 'react'


class CustomerDetailsTimeLine extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hover: false,
      selected: false,
      selectedStyle: '',
    }
  }

  componentDidMount() {

  }


  onEnter() {
    //this.setState({hover: true})
  }

  onExit() {
    //this.setState({hover: false})
  }




  getTime() {
    let day = new Date(this.props.item.timestamp)  // 2009-11-10
    let minutes = (day.getMinutes() < 10 ? '0' : '') + day.getMinutes()
    let hours = (day.getHours() < 10 ? '0' : '') + day.getHours()
    return hours + ':' + minutes
  }

    getMessage() {

        if (this.props.item.message !== '') {
            return this.props.item.message
        } else {
            return this.props.item.text
        }
    }

    getCarrier() {
        if (this.props.carrier == null) {

            if (typeof this.props.item.carrier !== 'undefined') {
                return (
                    <div className="checkPointDetailsCarrierInfoContainer">
                        <div className="carrierLogoSmall" style={{backgroundImage:'url("'+'https://cdn.tracefully.com/carriers/' + this.props.item.carrier.name + '.svg'+'")'}}>
                        </div>
                        {this.props.item.carrier.fullname}
                    </div>
                )
            } else {
                return ('')
            }

        } else {
            return (
                <div className="checkPointDetailsCarrierInfoContainer">
                    <img className="carrierLogoSmall"
                         src={'https://cdn.tracefully.com/carriers/' + this.props.carrier.value + '.svg'}/>
                    {this.props.carrier.label}
                </div>
            )
        }
  }


    getInfo() {
    let typeCard = ''
        let position= ''
        let TypeInfoBox = ''
        let carrier = this.getCarrier()

        if (this.props.item.type === 'Delivered') {
            typeCard = (
                <div className="checkPointDetailsTypeCard TypeDelivery">
                    {this.props.item.type_detail.name}
                </div>
            )
        } else if (this.props.item.type === 'In Transit') {
            typeCard = (
                <div className="checkPointDetailsTypeCard TypeTransfer">
                    {this.props.item.type_detail.name}
                </div>
            )
        } else if (this.props.item.type === 'Out For Delivery') {
            typeCard = (
                <div className="checkPointDetailsTypeCard TypeOutForDelivery">
                    {this.props.item.type_detail.name}
                </div>
            )
        }else if (this.props.item.type === 'Exception') {
            typeCard = (
                <div className="checkPointDetailsTypeCard TypeException">
                    {this.props.item.type_detail.name}
                </div>
            )
        }




        if ((this.props.item.position != null && this.props.item.position !== '')) {
            position = (
                <div className="checkpointPositionTag">
                    {this.props.item.position.formatted_address_short}
                </div>

            )
            return (
                <div className="checkPointDetailsContainer">
                    <div className="TypeInfoRow">
                        {carrier}
                        {typeCard}
                        {position}
                    </div>

                </div>
            )
        }

        return (
            <div className="checkPointDetailsContainer">
                <div className="TypeInfoRow">
                    {carrier}
                    {typeCard}
                </div>
            </div>
        )


    }


  render() {

    let formatTime = this.getTime()
    let message = this.getMessage()

    let info = this.getInfo()

    return (

        <div className="timeline-section">
          <div className="timeline-date">
            {formatTime}
          </div>
          <div className="checkPointContainer">
            <div
                role="button"
                className={'CDT-TimeLineItemContainer hasInfo ' + this.state.selectedStyle}
                style={{float: 'left'}}

                onMouseEnter={() => this.onEnter()}
                onMouseLeave={() => this.onExit()}
            >
              <div className="checkpointMessage ">
                {message}
              </div>
                {info}

            </div>


          </div>
        </div>


    )
  }
}

export default CustomerDetailsTimeLine
